// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"695":"7a8d38e3","845":"a7eedba2"}[chunkId] + ".chunk.js";
};